import { ReactNode } from "react";
import { Button, Drawer, Typography } from "@/components/atoms";

interface FormBottomSheetProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  submitLabel: string;
  onSubmit: () => void;
  submitDisabled?: boolean;
  cancelDisabled?: boolean;
  children: ReactNode;
}

/**
 * Mobile bottom-sheet form scaffold — the <md counterpart of the Modal layouts used at md+:
 * left-aligned title/description header, form body, stacked full-width primary + text Cancel.
 */
export const FormBottomSheet = ({
  open,
  onClose,
  title,
  description,
  submitLabel,
  onSubmit,
  submitDisabled,
  cancelDisabled,
  children,
}: FormBottomSheetProps) => (
  <Drawer open={open} onOpenChange={(next) => !next && onClose()}>
    <span className="hidden" />
    <div className="flex flex-col gap-5 px-1 pb-6 pt-3">
      <div>
        <Typography variant="action" className="block text-neutral-black">
          {title}
        </Typography>
        <Typography variant="muted" className="mt-1 block text-neutral-dark-gray">
          {description}
        </Typography>
      </div>
      {children}
      <div className="flex flex-col gap-3">
        <Button variant="primary" size="lg" className="w-full" onClick={onSubmit} disabled={submitDisabled}>
          {submitLabel}
        </Button>
        <button type="button" onClick={onClose} disabled={cancelDisabled} className="py-2">
          <Typography variant="action" className="text-info">
            Cancel
          </Typography>
        </button>
      </div>
    </div>
  </Drawer>
);
